<template>
    <div class="content-wrap sun ques ">
        <div class="content-top-wrap count-down">
            <i class="icon icon-clock"/>
            <CountDown
                ref="countDown"
                @finish="() => handleAns('countDown')"
                :time="30 * 1000"
                format="ss"
                />
        </div>
        <div class="que-content-warp">
            <div ref="content">
                <QueItem
                    :question="questions[index]"
                    :val.sync="answers[questions[index].quiz_id]">
                    <span v-if="questions.length" slot="queIndex">
                        {{index + 1}}/{{questions.length}}
                    </span>
                </QueItem>
            </div>
        </div>
        <div class="content-bottom-wrap">
            <Button
                class="btn btn-primary"
                :disabled="!canNext"
                @click="handleAns"
            >{{questions.length - 1 > index ? '下一题' : '提交'}}</Button>
        </div>
    </div>
</template>

<script>
import { CountDown, Button } from 'vant';
import QueItem from '@/components/Question';
import { throttle } from '@/utils/func'
export default {
    name: 'ques',
    props: ['questions'],
    components: {
        CountDown,
        QueItem,
        Button
    },
    watch: {
        index () {
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
            this.$refs.content.scrollTop = 0
        },
    },
    computed: {
        canNext: function () {
            console.log(this.answers)
            return this.answers[this.questions[this.index].quiz_id]
        }
    },
    data() {
        return {
            index: 0,
            answers:{},
        };
    },
    mounted() {
    },
    methods: {
        handleAns: throttle(function (type = '') {
            if (!this.answers[this.questions[this.index].quiz_id] ) {
                this.answers[this.questions[this.index].quiz_id] = {
                    seq_id: 0,
                    score: this.questions[this.index].score
                }
            }

            // 超时已选不积分
            if (type === 'countDown') {
                this.answers[this.questions[this.index].quiz_id] = {
                    seq_id: 0,
                    score: this.questions[this.index].score
                }
            }

            if (this.questions.length > Object.keys(this.answers).length) {
                this.index ++
            } else {
                this.$emit('submit', this.answers)
            }
        }, 200),
    }
};
</script>
<style lang="less" scoped>
.ques {
    .btn{
        margin: auto;
    }
    .count-down {
        display: flex;
        justify-content: flex-end;
        margin: 1.7rem 1.9rem;
        position: absolute;
        top: 0;
        right: 0;
        /deep/.van-count-down, .icon {
            display: inline-block;
            color: #fff;
            font-size: 1.3rem;
            font-weight: bold;
            line-height: 2.1rem;
        }
        /deep/.van-count-down {
            width: 2rem;
            text-align: center;
        }
        .icon {
            margin-right: .5rem;
            font-size: 2.1rem;
        }
    }
    .que-content-warp {
        position: relative;
        margin: 15vh auto 0;
        height: 1;
        background: #fff;
        flex: 1;
        padding: 2rem 1rem;
        width: calc(76vw - 2rem);
        >div {
            padding: 0 1rem;
            width: calc(100% - 2rem);
            max-height: 100%;
            overflow: scroll;
        }
    }
    .content-bottom-wrap {
        flex: inherit;
        margin: 3rem auto;
    }
}
</style>
<style lang="less">
.hevue-imgpreview-wrap {
    .he-close-icon {
        color: #fff;
        background: transparent;
        transition: unset;
        transform: none;
    }
    
}
.hevue-imgpreview-wrap .he-close-icon:hover {
  transform: 0;
}
</style>
